import Vue from 'vue'
import YmapPlugin from 'vue-yandex-maps'

const settings = {
  apiKey: '8ff3cefc-992c-4eac-9222-4a4c4b729e12',
  lang: 'ru_RU',
  coordorder: 'latlong'
}

Vue.use(YmapPlugin, settings)